
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    // Forzamos el scroll al inicio de la página
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
};

export default ScrollToTop;
